import Request from '~/providers/Request';

const fetchAllExamsIds = async (input, page, resolve) => {

  await Request.get('/admin/exams', {
    sorter: 'name.asc',
    qs: input,
    page: page,
    perPage: 50,
  }).then((resp) => {
    const items = resp.data.map((e) => ({
      id: Number(e.id),
      name: `${e?.description}`,
      external_id: e?.external_id,
    }));
    resolve({
      total_count: resp.meta.total,
      items: [
        ...items
      ]
    });
  });
  
};

export default fetchAllExamsIds;
